'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmpty;

var _count2 = require('./internal/_count');

var _count3 = _interopRequireDefault(_count2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns true if `value` is "empty".
 * If given null, undefined, isEmpty will return true.
 *
 * @param {any} value
 * @return {boolean}
 */
function isEmpty(value) {
  if (!value) {
    return true;
  }
  return (0, _count3.default)(value) === 0;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/isEmpty.js
// module id = 1034
// module chunks = 2 3